import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { Event } from "event-system";

export class ConnectWalletView extends Container {
    private static readonly HEADER_TEXT = 'CONNECT WALLET';
    private static readonly METAMASK = 'METAMASK';
    private static readonly COINBASE = 'COINBASE';

    private readonly myWalletResources: MyWalletResourcePackage;
    private readonly commonResources: CommonResourcesPackage;

    private headerText: Text;
    private metamaskButton: ButtonWithScaleAnimation;
    private coinbaseButton: ButtonWithScaleAnimation;
    private line: Sprite;

    public readonly onConnectWalletClick: Event<ConnectedWalletType>;

    public constructor(commonResources: CommonResourcesPackage, myWalletResources: MyWalletResourcePackage) {
        super();
        this.commonResources = commonResources;
        this.myWalletResources = myWalletResources;
        this.onConnectWalletClick = new Event();
        this.build();
        this.layout();
        this.metamaskButton.onUp.add(this.onMetamaskButtonClickHandle, this);
        this.coinbaseButton.onUp.add(this.onCoinbaseButtonClickHandle, this);
    }

    private build(): void {
        this.headerText = new Text(ConnectWalletView.HEADER_TEXT, new ComponentTextStyle());
        this.metamaskButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_web3_metamask_icon_png);
        const metamaskButtonText = new Text(ConnectWalletView.METAMASK, new ComponentTextStyle());
        metamaskButtonText.position.set(90, 21);
        this.metamaskButton.defaultView.addChild(metamaskButtonText);
        this.coinbaseButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_web3_coinbase_icon_png);
        const coinbaseButtonText = new Text(ConnectWalletView.COINBASE, new ComponentTextStyle());
        coinbaseButtonText.position.set(90, 21);
        this.coinbaseButton.defaultView.addChild(coinbaseButtonText);
        this.line = new Sprite(this.myWalletResources.assets_views_my_wallet_ui_line_png);

        this.addChild(
            this.headerText,
            this.metamaskButton,
            this.coinbaseButton,
            this.line
        );
    }

    private layout(): void {
        this.headerText.position.set(183, 72);
        this.metamaskButton.position.set(184, 164);
        this.coinbaseButton.position.set(194, 284);
        this.line.position.set(94, 259);
    }

    private onMetamaskButtonClickHandle(): void {
        this.onConnectWalletClick.emit(ConnectedWalletType.METAMASK);
    }

    private onCoinbaseButtonClickHandle(): void {
        this.onConnectWalletClick.emit(ConnectedWalletType.COINBASE);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.metamaskButton.onUp.remove(this.onMetamaskButtonClickHandle, this);
        this.coinbaseButton.onUp.remove(this.onCoinbaseButtonClickHandle, this);
        super.destroy(options);
    }
}

export enum ConnectedWalletType {
    METAMASK = 'METAMASK',
    COINBASE = 'COINBASE'
}

class ComponentTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 48,
            fill: 'FFFFFF'
        });
    }
}